import { EmptyState } from "@/components/EmptyState/EmptyState";
import { NoSearchResultsSvg } from "@/components/Icon/Icon";
import { useTranslation } from "react-i18next";

export const NoSearchResult = () => {
  const { t } = useTranslation("common");

  return (
    <EmptyState
      image={<NoSearchResultsSvg style={{ width: "240px" }} />}
      title={t("message.noMatches")}
      message={t("message.noMatchesHelp")}
      sx={{ height: undefined, marginTop: "5em" }}
    />
  );
};
